import { ScrollArea as BaseScrollArea } from '@base-ui/react/scroll-area';
import { StyledCorner, StyledRoot, StyledScrollbar, StyledThumb, Viewport } from './styled';
export function ScrollArea(props) {
    const { children, className } = props;
    return (<StyledRoot>
      <Viewport className={className} style={{ scrollbarWidth: 'none' }}>
        <BaseScrollArea.Content style={{ minWidth: 'unset' }}>{children}</BaseScrollArea.Content>
      </Viewport>
      <StyledScrollbar>
        <StyledThumb />
      </StyledScrollbar>
      <StyledCorner />
    </StyledRoot>);
}
